import { ErrorHandler, inject, Injectable } from '@angular/core';

import { LoggerService } from '@core/services/logger.service';
import { isChunkLoadError, reloadOnceForStaleChunk } from '@core/utils/chunk-load-error.util';

/**
 * Catches unhandled errors from the change detection / zone (like v16 `SentryErrorHandler` stub,
 * but routes through {@link LoggerService} for consistent behavior and future APM integration.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  handleError(error: unknown): void {
    if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
      this.logger.warn('Stale lazy chunk detected — reloading the app once');
      return;
    }

    try {
      this.logger.error('Unhandled application error', error);
    } catch {
      console.error(error);
    }
  }
}
